import theme from '@ifca-root/react-component/src/assets/theme'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  useMediaQuery,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import { SubmitterDialog } from 'components/Dialog/SubmitterDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { TooltipAmountFooter } from 'components/Footer/TooltipAmountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  ApprovalStatus,
  usePostInvoiceAmortisationMutation,
  useRejectInvoiceAmortisationMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  dateFormat,
  formatDate,
  formatTime,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'

export const InvoiceAmortisationPostingList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    postIDs,
    setPostIDs,
    userList,
    setOriginalListing,
    loadData,
  } = props

  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { menu: menu2, handleClick: handleClick2 }: any = useMenuOption()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [openDialog, setOpenDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const [clickReject, setIsReject] = useState(false)
  const [rejectDialogInput, setRejectDialogInput] = useState({
    RejectionRemark: '',
  })
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [postDialog, setPostDialog] = useState(false)

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    postInvoiceAmortisation,
    { loading: postInvoiceAmortisationLoading },
  ] = usePostInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setPostDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.postNewRecord())
      setPostIDs(new Set([]))
      setOriginalListing([])
      loadData({
        variables: {
          CompanyID: CompanyID,
          StatusArr: 'SUBMIT',
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name !== '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  const [
    rejectInvoiceAmortisation,
    { loading: RejectInvoiceAmortisationLoading },
  ] = useRejectInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.rejectNewRecord())
      setPostIDs(new Set([]))
      setOriginalListing([])
      loadData({
        variables: {
          CompanyID: CompanyID,
          StatusArr: 'SUBMIT',
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name !== '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */
  // handle checkbox for all employee
  const handleSelectAll = e => {
    let jTemp = postIDs
    if (e.target.checked) {
      filteredList.map(v => {
        jTemp.add(v?.AmortisationID)
      })
    } else {
      jTemp.clear()
    }
    setPostIDs(new Set(jTemp))
  }

  const handleCheckBoxChange = (e: any, postID, index: number) => {
    let temp = postIDs
    if (!temp.has(postID)) {
      temp.add(postID)
    } else {
      temp.delete(postID)
    }
    setPostIDs(new Set(temp))
  }

  let listPostIDs: any = Array.from(postIDs || [])

  let checkedData = []
  listPostIDs.map(ID => {
    filteredList.map((el, i) => {
      if (el?.AmortisationID === ID) {
        checkedData.push(...el?.AmortisationItem)
      }
    })
  })

  const { handlePermDisabled } = usePermissionChecker()

  /* -------------------------------------------- */
  /*                    SUBMIT                   */
  /* -------------------------------------------- */
  const onSubmitApprove = (listPostIDs, status) => {
    postInvoiceAmortisation({
      variables: {
        AmortisationIDs: listPostIDs,
        CompanyID: CompanyID,
        ApprovalStatus: status,
      },
    })
  }

  const onSubmitReject = () => {
    rejectInvoiceAmortisation({
      variables: {
        AmortisationIDs: listPostIDs,
        input: {
          RejectionRemark: rejectDialogInput?.RejectionRemark,
        },
      },
    })
  }

  useEffect(() => {
    if (clickReject) {
      onSubmitReject()
    }
  }, [clickReject])

  return (
    <>
      {listLoading && <Loading />}
      {postInvoiceAmortisationLoading && <Loading />}
      {RejectInvoiceAmortisationLoading && <Loading />}
      <ContentWrapper
        footer
        overflow
        style={{ marginTop: isDesktop ? '70px' : '-7px' }}
      >
        {listStatus === 'SUBMIT' && filteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              onChange={handleSelectAll}
              color="primary"
              value={''}
              checked={postIDs?.size === filteredList?.length}
              style={{ marginLeft: '-5px', marginTop: '-5px' }}
              //   disabled={handlePermDisabled({
              //     companyID: CompanyID,
              //     permEnum:
              //       AcctPermission.GeneralLedgerJournalProcessingApproveReject,
              //   })}
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                loadData({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name !== '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              <>
                {filteredList
                  ?.filter(item => item.ApprovalStatus === listStatus)
                  ?.map((el, index) => {
                    const totalAmount = el.AmortisationItem.reduce(
                      (sum, item) => {
                        return (
                          sum +
                          item.AmortisationItemDetail.reduce(
                            (detailSum, detail) => detailSum + detail.Amount,
                            0
                          )
                        )
                      },
                      0
                    )
                    return (
                      <ListItem key={index}>
                        {listStatus === 'SUBMIT' ? (
                          <FormControl
                            component="fieldset"
                            style={{ width: '16px' }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  value={el.AmortisationID}
                                  onChange={e => {
                                    handleCheckBoxChange(
                                      e,
                                      el?.AmortisationID,
                                      index
                                    )
                                  }}
                                  onClick={e => e.stopPropagation()}
                                  checked={postIDs?.has(el?.AmortisationID)}
                                  color="primary"
                                  style={{
                                    marginLeft: '10px',
                                    marginRight: '-5px',
                                  }}
                                  // disabled={handlePermDisabled({
                                  //   companyID: CompanyID,
                                  //   permEnum:
                                  //     AcctPermission.GeneralLedgerJournalProcessingApproveReject,
                                  // })}
                                />
                              }
                              label=""
                              name="check"
                            />
                          </FormControl>
                        ) : null}

                        <ListItemText
                          style={{
                            marginLeft: listStatus === 'SUBMIT' ? '25px' : null,
                          }}
                          primary={
                            <>
                              <span
                                className={`xsTitle flex-space`}
                                style={{ fontSize: '12px' }}
                              >
                                {el?.Invoice?.DocNo}
                              </span>
                              <span
                                className="desc"
                                style={{
                                  whiteSpace: 'break-spaces',
                                  lineBreak: 'auto',
                                }}
                              ></span>
                              <span
                                className="desc"
                                style={{
                                  fontSize: '12px',
                                  color: 'black',
                                }}
                              >
                                {dateFormat(el?.Invoice?.DocDate)}
                              </span>
                            </>
                          }
                          secondary={
                            <>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <span style={{ fontSize: '10px' }}>
                                    {el?.Invoice?.DebtorAccount?.DebtorName}
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={10}>
                                  {
                                    <div className="icon-text">
                                      <Tooltip
                                        disableFocusListener
                                        title={
                                          <Fragment>
                                            <Grid
                                              container
                                              wrap="nowrap"
                                              spacing={2}
                                            >
                                              <Grid item>
                                                <IconText
                                                  icon={
                                                    <img
                                                      src={SubmitterLog}
                                                      style={{
                                                        width: '12px',
                                                        marginRight: '3px',
                                                      }}
                                                    />
                                                  }
                                                  font="desc"
                                                />
                                              </Grid>
                                              <Grid item xs zeroMinWidth>
                                                <div
                                                  style={{ fontSize: '12px' }}
                                                >
                                                  {userList?.find(
                                                    x =>
                                                      x?.ID === el?.approvedBy
                                                  )?.name ??
                                                    userList?.find(
                                                      x =>
                                                        x?.ID === el?.createdBy
                                                    )?.name}
                                                </div>
                                                <div
                                                  style={{ fontSize: '10px' }}
                                                >
                                                  {formatDate(
                                                    el?.approvedTs ??
                                                      el?.createdTs
                                                  )}{' '}
                                                  &nbsp;
                                                  {formatTime(
                                                    el?.approvedTs ??
                                                      el?.createdTs
                                                  )}
                                                </div>
                                              </Grid>
                                            </Grid>
                                          </Fragment>
                                        }
                                        arrow
                                        enterTouchDelay={0}
                                      >
                                        <div>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          />
                                        </div>
                                      </Tooltip>
                                      <span
                                        className="desc text-noflow"
                                        style={{ display: 'contents' }}
                                      >
                                        {el?.Invoice?.Description}
                                      </span>
                                    </div>
                                  }
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  style={{ textAlign: 'right' }}
                                >
                                  <span className="xxTitle">
                                    <span className="c-orange">
                                      <span style={{ fontSize: '12px' }}>
                                        {amtStr(totalAmount)}
                                      </span>
                                    </span>
                                  </span>
                                </Grid>
                              </Grid>
                            </>
                          }
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            aria-label="arrow"
                            // disabled={handlePermDisabled({
                            //   companyID: CompanyID,
                            //   permEnum:
                            //     AcctPermission.AccReceivableGenerateScheduledBillingView,
                            // })}
                          >
                            <KeyboardArrowRight
                              onClick={() =>
                                history.push({
                                  pathname: `/account-receivable/${CompanyID}/invoice-amortisation/${el?.AmortisationID}/detail`,
                                  state: el,
                                })
                              }
                            />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    )
                  })}
              </>
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>

      <SubmitterDialog
        data={menu2?.obj}
        setOpenDialog={setOpenDialog}
        openDialog={openDialog}
        moduleName={'Invoice Amortisation'}
      />

      <TooltipAmountFooter data={checkedData} module={`amortisation-submit`} />

      {listStatus === 'SUBMIT' ? (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => {
                setOpenRejectDialog(true)
              },
              color: 'secondary',
              props: {
                disabled: postIDs.size === 0,
                // ||
                // handlePermDisabled({
                //   companyID: CompanyID,
                //   permEnum:
                //     AcctPermission.GeneralLedgerJournalProcessingApproveReject,
                // }),
              },
            },
            {
              name: 'Approve',
              onClick: () => {
                onSubmitApprove(listPostIDs, ApprovalStatus.Completed)
              },
              color: 'primary',
              props: {
                disabled: postIDs.size === 0,
                // ||
                // handlePermDisabled({
                //   companyID: CompanyID,
                //   permEnum:
                //     AcctPermission.GeneralLedgerJournalProcessingApproveReject,
                // }),
              },
            },
          ]}
        />
      ) : null}

      <RejectDialog
        data={filteredList}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />

      <ErrorDialog
        errorDia={postDialog}
        setErrorDia={setPostDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
        isBool
        onclick={() => {
          setPostDialog(false)
          window.location.reload()
        }}
      />
    </>
  )
}
